export default __webpack_public_path__ + "static/space-access-dark-021a9dff1c281fac80b32552a5e6c089.png";